import React from 'react';
import Logos from '../sections/Logos';
//import {Link} from 'react-router-dom';
import MiddleLink from '../components/MiddleLink';
import HomeCaseStudies from '../sections/HomeCaseStudies';
import certAws from '../images/certs/aws.png';
import certZce from '../images/certs/zce.png';
import certDc from '../images/certs/dc.png';
import '../css/Home.css';

function Home() {
  return (
    <div className="bww-page page-home">
    {/* <div className="no-select headshot_contain"><img className="headshot" src="./images/dbushnell_drawn_401000_x1.png" alt="Pencil drawing of Dave Bushnell" /></div> */}
      <p className="bww-question">{" "}</p>
      <div className="bww-intro ">
        <div className="ornament">
          <a href="https://www.c-span.org/video/?c4844066/user-clip-dave-bushnell-nixonfoundationorg" rel="noopener noreferrer" target="_blank">
          <img src="./images/davebushnell-rnf.jpg" alt="Still from CSPAN video showing Dave Bushnell presenting to VIP audience" />
          </a>

          <p className="bww-answer"><b>Open to Senior/Staff/Principal roles (remote U.S. or LA-hybrid) across product engineering and platform teams—especially where content scale, performance, and modernization matter.</b></p>
        </div>
        <div className="content">
          <p class="bww-answer"><strong>New (2026): </strong>Launched <a href="https://wordpress.org/plugins/engagemuse-insights/" rel="noreferrer noopener" target="_blank">EngageMuse Insights</a>, an AI-powered WordPress plugin.</p>
          
          <p className="bww-answer">I’m Dave Bushnell, a principal-level engineer and technical lead based in Los Angeles. I lead teams shipping high-traffic, user-facing web experiences with an emphasis on performance, accessibility, and maintainable architecture. My core toolkit is modern web engineering (React/TypeScript, component systems, API integration, CI/CD, AWS); I'm also skilled in old-school practices (enterprise WordPress customization expertise, performance/SEO hardening), shipping content platforms that are fast for users and frictionless for publishers. Recently, I also helped launch a production Claude-driven chatbot, and released <a href="https://wordpress.org/plugins/engagemuse-insights/" rel="noreferrer noopener" target="_blank">EngageMuse Insights</a>, an AI-powered WordPress plugin.</p>

          <ul>
            <li>Frontend architecture: React/TypeScript, design systems, performance tuning, accessibility</li>

            <li>Platform delivery: CI/CD, safe release practices, automation, and operational readiness</li>

            <li>Enterprise WordPress expertise: bespoke themes/plugins, Gutenberg/editor UX, WP APIs, workflow + governance, as well as headless/hybrid builds</li>

            <li>SEO + content scale: Core Web Vitals, technical SEO, publishing velocity without breaking production</li>

            <li>Practical AI shipping: LLM-driven UX, guardrails, evaluation mindset, rollout readiness</li>

            <li>Leadership: mentoring, cross-functional alignment, decomposing complex work into shippable slices</li>
          </ul>
          

        </div>
      </div>

      

      <HomeCaseStudies />

      <p className="bww-answer"><b>Certifications:</b></p>
      <p className="bww-answer">
        <span className="certshow">
          <span className="certitem">
            <span className="certbadge" style={{backgroundImage: `url(${certAws})`}} />
            <span className="certinfo">AWS Certified Developer Associate</span>
          </span>
          <span className="certitem">
            <span className="certbadge" style={{backgroundImage: `url(${certZce})`}} />
            <span className="certinfo">Zend Certified PHP Engineer</span>
          </span>
          <span className="certitem">
            <span className="certbadge" style={{backgroundImage: `url(${certDc})`}} />
            <span className="certinfo">DoubleClick Studio Certified (Core and QA)</span>
          </span>
        </span>
      </p>


      <p className="bww-answer"><a href="https://medium.com/@bushnellwebworks" rel="noopener noreferrer" target="_blank">View my Medium articles</a> on WordPress development.</p>
      
      <p className="bww-question">Code samples</p>
      <ul>
        <li><a href="https://gitlab.com/bushnellwebworks/wp-projects/-/tree/41de4d874d4f29d7f9ccb724be9e80711d98f558/plugins/engagemuse" rel="noopener noreferrer" target="_blank">An AI-powered WordPress plugin</a> I recently developed <i>(currently under review)</i></li>
        <li>I originated this code for a decoupled blog, and led teams to maintain and update it. <i>(This project was decommissioned, and code is presented with permission.)</i></li>
        <ul>
          <li><a href="https://gitlab.com/bushnellwebworks/fe-itshome/-/blob/main/README.md" rel="noopener noreferrer" target="_blank">Frontend</a> - GatsbyJS and others</li>
          <li><a href="https://gitlab.com/bushnellwebworks/cms-itshome/-/blob/main/README.md" rel="noopener noreferrer" target="_blank">CMS</a> - WordPress (PHP / React) and others</li>
        </ul>
        <li><a href="https://gitlab.com/bushnellwebworks/wj-pwa/-/blob/master/README.md" rel="noopener noreferrer" target="_blank">PWA</a> - GatsbyJS, Amazon (Amplify/Cognito) and others</li>
      </ul>
      <br />
      <p className="bww-question">Legacy projects</p>
      <p className="bww-answer"><MiddleLink to="/work-rnf">Browse my legacy case studies</MiddleLink> from work prior to 2020.</p>
      <p className="bww-answer"><a href="https://www.wpcraftsman.com" rel="noopener noreferrer" target="_blank">Read my old blog</a> on WordPress development topics.</p>
      <p className="bww-answer"><a href="https://github.com/BushnellWebWorks?tab=repositories" rel="noopener noreferrer" target="_blank">A handful of code samples</a> of old doohickeys in different languages.</p>
      <p style={{textAlign:'center'}}><br /><i>Résumé and references available on request</i></p>
      <Logos />
    </div>
  );
}

export default Home;
